export default "__VITE_ASSET__Db2f_nTV__"